const PLANS = {
  starter: {
    limits: { leadsPerMonth: 500, emailsPerDay: 0, teamMembers: 2, administrators: 1 },
    features: {
      cnpjSearch: true,
      aiSearch: true,
      crm: true,
      automation: false,
      emailOutreach: false,
      whatsapp: false,
      exportLeads: false,
      api: false,
      sla: false,
    },
  },
  growth: {
    limits: { leadsPerMonth: 2500, emailsPerDay: 60, teamMembers: 4, administrators: null },
    features: {
      cnpjSearch: true,
      aiSearch: true,
      crm: true,
      automation: true,
      emailOutreach: true,
      whatsapp: false,
      exportLeads: true,
      api: false,
      sla: false,
    },
  },
  pro: {
    limits: { leadsPerMonth: 5000, emailsPerDay: 150, teamMembers: 6, administrators: null },
    features: {
      cnpjSearch: true,
      aiSearch: true,
      crm: true,
      automation: true,
      emailOutreach: true,
      whatsapp: true,
      exportLeads: true,
      api: false,
      sla: false,
    },
  },
  enterprise: {
    limits: { leadsPerMonth: 10000, emailsPerDay: 360, teamMembers: 10, administrators: null },
    features: {
      cnpjSearch: true,
      aiSearch: true,
      crm: true,
      automation: true,
      emailOutreach: true,
      whatsapp: true,
      exportLeads: true,
      api: true,
      sla: true,
    },
  },
};

export function normalizePlanEntitlements(value = {}) {
  const plan = Object.prototype.hasOwnProperty.call(PLANS, String(value?.plan || '').toLowerCase())
    ? String(value.plan).toLowerCase()
    : 'starter';
  const defaults = PLANS[plan];
  const limits = value.status === 'free'
    ? { ...defaults.limits, leadsPerMonth: 50 }
    : defaults.limits;
  return {
    ...value,
    plan,
    displayName: value.displayName || `${plan[0].toUpperCase()}${plan.slice(1)}`,
    limits: { ...limits, ...(value.limits || {}) },
    features: { ...defaults.features, ...(value.features || {}) },
    usage: value.usage || {},
  };
}

export function isPlanFeatureEnabled(entitlements, feature) {
  return normalizePlanEntitlements(entitlements).features[feature] === true;
}

// Credit purchases and an onboarding plan selection never grant subscription access.
export function hasActivePaidSubscription(entitlements) {
  return ['active', 'trialing'].includes(entitlements?.status)
    && Object.prototype.hasOwnProperty.call(PLANS, entitlements?.plan);
}

export function isPaidFeatureAvailable(entitlements, feature) {
  if (entitlements?.paidFeatures != null) return entitlements.paidFeatures[feature] === true;
  if (!hasActivePaidSubscription(entitlements)) return false;
  if (feature === 'enrichment') return entitlements.features?.enrichment !== false;
  const planFeature = feature === 'mailbox' ? 'emailOutreach' : feature;
  return isPlanFeatureEnabled(entitlements, planFeature);
}

export function allowedOutreachChannels(entitlements) {
  const value = normalizePlanEntitlements(entitlements);
  if (!value.features.automation) return [];
  return [
    value.features.emailOutreach ? 'email' : null,
    value.features.whatsapp ? 'whatsapp' : null,
  ].filter(Boolean);
}

export function planFeatureReason(entitlements, feature) {
  if (isPlanFeatureEnabled(entitlements, feature)) return '';
  if (feature === 'whatsapp') return 'WhatsApp está disponível nos planos Pro e Enterprise.';
  if (feature === 'exportLeads') return 'Exportação está disponível a partir do plano Growth.';
  return 'Automação de e-mail está disponível a partir do plano Growth.';
}
